var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCny = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 10.7704 16.1158 12.9051 14.5104 14.5104C12.9051 16.1158 10.7704 17 8.5 17C6.22961 17 4.09488 16.1158 2.48959 14.5104C0.884163 12.9051 0 10.7704 0 8.5C0 6.22961 0.884163 4.09488 2.48959 2.48959C4.09488 0.884163 6.22961 0 8.5 0C10.7704 0 12.9051 0.884163 14.5104 2.48959C16.1158 4.09488 17 6.22961 17 8.5Z",
    fill: "#EE4B39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 10.7704 16.1158 12.9051 14.5104 14.5104C12.9051 16.1158 10.7704 17 8.5 17V0C10.7704 0 12.9051 0.884163 14.5104 2.48959C16.1158 4.09488 17 6.22961 17 8.5Z",
    fill: "#C03425"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.207 8.5C15.207 12.1981 12.1981 15.207 8.5 15.207C4.80187 15.207 1.79297 12.1981 1.79297 8.5C1.79297 4.80187 4.80187 1.79297 8.5 1.79297C12.1981 1.79297 15.207 4.80187 15.207 8.5Z",
    fill: "#A13226"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46446 7.58674L9.39576 5H11.1741L9.65005 8.55677H10.6706V9.50322H9.31492V10.0017H10.6706V10.9431H9.31492V12.2533H7.5719V10.9431H6.06297V10.0017H7.5719V9.50322H6.06297V8.55677H7.27887L5.74805 5H7.53148L8.46446 7.58674Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCny);
export default ForwardRef;